import { selectSidebarOpen, selectUI } from '../selectors';
import { useAppSelector, useAppDispatch } from './core';
import { toggleSidebar, setSidebarOpen } from '../slices/uiSlice';

/**
 * Hook to select UI-related state
 */
export function useUIState() {
  const uiState = useAppSelector(selectUI);
  const sidebarOpen = useAppSelector(selectSidebarOpen);
  const dispatch = useAppDispatch();

  return {
    ...uiState,
    sidebarOpen,
    toggleSidebar: () => {
      dispatch(toggleSidebar());
    },
    setSidebarOpen: (open: boolean) => {
      dispatch(setSidebarOpen(open));
    },
  };
}
